export default __webpack_public_path__ + "static/media/comment.ff06aa35.svg";